// extracted by mini-css-extract-plugin
export default {"title":"d0d032e561","inner_title":"_1a52e02dde","charge_btn":"_4156374415"};